export function appendBlock(messages, block) {
    const lastMsg = messages[messages.length - 1];

    if (lastMsg?.role === "assistant") {
        const next = [...messages];
        next[next.length - 1] = { ...lastMsg, blocks: [...(lastMsg.blocks || []), block] };
        return next;
    }

    return [...messages, { role: "assistant", blocks: [block] }];
}

// Extends the assistant's trailing text block, or opens one after any non-text block.
export function appendTextDelta(messages, delta) {
    const text = delta || "";
    const lastMsg = messages[messages.length - 1];

    if (lastMsg?.role !== "assistant") {
        return [...messages, { role: "assistant", blocks: [{ block_type: "text", text }] }];
    }

    const blocks = [...(lastMsg.blocks || [])];
    const lastBlock = blocks[blocks.length - 1];

    if (lastBlock?.block_type === "text") {
        blocks[blocks.length - 1] = { ...lastBlock, text: lastBlock.text + text };
    } else {
        blocks.push({ block_type: "text", text });
    }

    const next = [...messages];
    next[next.length - 1] = { ...lastMsg, blocks };
    return next;
}

// Removes the trailing assistant placeholder and the user message before it, whichever exist.
export function dropOptimisticTurn(messages) {
    const next = [...messages];
    if (next[next.length - 1]?.role === "assistant") next.pop();
    if (next[next.length - 1]?.role === "user") next.pop();
    return next;
}
